export default {
    planSelected: state => state.planSelected,
    getPlans: state => state.plans,
    getProduct: state => state.product,
    getPrefilledData: state => state.prefillData,
    getActivePlan: state => state.activePlan,
    getDescriptorText: state => state.descriptorText,
    paymentLocked: state => state.paymentLocked,
    paymentLockedError: state => state.paymentLockedError,
    skipMobileSummary: state => state.skipMobileSummary,
};